import React from 'react';
import { Link } from 'react-router-dom';

function Failure() {
    return (
        <>
            <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                There was a problem resetting your password. Please{' '}
                <Link to="/login/reset-password" className="display8 accent">
                    request a new reset password email
                </Link>
                .
            </p>

            <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                Still need help?
            </p>

            <p className="text-center mb-4 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                <a className="accent" href="mailto:membership@icsc.com">
                    Contact us.
                </a>
            </p>
        </>
    );
}

export default Failure;
